import type { InterviewLanguage } from "@repo/app-types/constants/languages";
import type { Assessment } from "@repo/app-types/entities/assessment";
import type {
  CustomFieldDefinition,
  CustomFieldDefinitionInsertClient,
} from "@repo/app-types/entities/customField";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import type { FC } from "react";
import { AssessmentEditor } from "./assessmentEditor.js";
import { renderAssessmentSettingsLabel } from "./helpers.js";

export interface AssessmentSettingsProps {
  language: InterviewLanguage;
  assessment: Assessment | null;
  fields: (CustomFieldDefinition | CustomFieldDefinitionInsertClient)[];
  setFields: (
    fields: (CustomFieldDefinition | CustomFieldDefinitionInsertClient)[],
  ) => void;
  fieldErrors: string[];
  setFieldErrors: React.Dispatch<React.SetStateAction<string[]>>;
}

export const AssessmentSettings: FC<AssessmentSettingsProps> = (props) => {
  const renderContent = () => {
    if (!props.assessment) {
      return null;
    }

    return (
      <AssessmentEditor
        interviewLanguage={props.language}
        fields={props.fields}
        setFields={props.setFields}
        fieldErrors={props.fieldErrors}
        setFieldErrors={props.setFieldErrors}
      />
    );
  };

  const content = renderContent();
  if (!content) {
    return null;
  }

  return (
    <>
      <div className="flex flex-row items-center space-x-2 border-b border-border-light px-3 py-2">
        <Label size={Size.SMALL}>{renderAssessmentSettingsLabel()}</Label>
      </div>
      {content}
    </>
  );
};
